module.exports = __webpack_public_path__ + "static/media/coffee_shop.2616a187.jpeg";